var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-pet"},[_c('h1',[_vm._v("Register A Pet")]),_c('add-pet-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }